import { v4 as uuidv4 } from 'uuid';

export interface ViewTemplate {
    id: string;
    name: string;
    overrides: {
        scale?: number;
        detailLevel?: 'Coarse' | 'Medium' | 'Fine';
        modelDisplay?: 'Wireframe' | 'HiddenLine' | 'Shaded' | 'ConsistentColors' | 'Realistic';
        visibleCategories?: string[]; // Allowed categories
        filters?: string[]; // Applied filter IDs
    };
}

export class ViewTemplateManager {
    private templates: Map<string, ViewTemplate> = new Map();

    constructor() {
        // Default Template
        this.createTemplate('Architectural Plan 1:100', {
            scale: 100,
            detailLevel: 'Medium',
            modelDisplay: 'HiddenLine'
        });
    }

    createTemplate(name: string, overrides: ViewTemplate['overrides']): ViewTemplate {
        const id = uuidv4();
        const template: ViewTemplate = { id, name, overrides };
        this.templates.set(id, template);
        return template;
    }

    getTemplate(id: string): ViewTemplate | undefined {
        return this.templates.get(id);
    }

    /**
     * Apply template properties to a view object.
     * Note: This modifies the view object directly (or returns partial update).
     */
    applyTemplate(view: any, templateId: string): void {
        const template = this.getTemplate(templateId);
        if (!template) throw new Error(`Template ${templateId} not found`);

        if (template.overrides.scale !== undefined) view.scale = template.overrides.scale;
        if (template.overrides.detailLevel !== undefined) view.detailLevel = template.overrides.detailLevel;
        if (template.overrides.modelDisplay !== undefined) view.modelDisplay = template.overrides.modelDisplay;
        
        // Complex logic for categories would merge/replace
        // For prototype, we just set properties
    }
}
